<template>
  <section
    id="investors"
    class="investors module white">
    <div class="container med">
      <div class="investors-head">
        <div
          v-if="data.investors_headline"
          class="headline h1"
          v-html="data.investors_headline"></div>
      </div>
      <div class="investors">
        <div
          v-for="(item, index) in data.investors"
          :key="index"
          class="investor border-radius">
          <Imager
            v-if="item.investor"
            :image="item.investor"
            :native="true" />
        </div>
      </div>
      <div
        v-if="data.investors_link"
        class="btn-container">
        <a
          :href="data.investors_link.url"
          :target="data.investors_link.target"
          class="btn trans-black"
          >{{ data.investors_link.title }}</a
        >
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
   {
    "NAME": "InvestorsComponent",
    "CLASSNAME": "investors",
    "URL": "http://eikon.local/"
   }
  #ENDMETA */
import Imager from '@/components/utility/Imager.vue'
defineProps(['data'])
</script>

<style lang="scss">
.investors {
  .investors {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    &-head {
      margin: 0 0 80px;

      @include mobile {
        margin-bottom: 44px;
      }
    }

    .investor {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18.8%;
      height: 0;
      padding-bottom: 16%;
      margin-right: 1.5%;
      margin-bottom: 1.5%;
      background-color: $light-gray;

      &:nth-child(5n + 5) {
        margin-right: 0;

        @include tablet-landscape {
          margin-right: 2%;
        }

        @include mobile {
          margin-right: 4%;
        }
      }

      @include tablet-landscape {
        width: 32%;
        padding-bottom: 25%;
        margin-right: 2%;
        margin-bottom: 2%;

        &:nth-child(3n + 3) {
          margin-right: 0;

          @include mobile {
            margin-right: 4%;
          }
        }
      }

      @include mobile {
        width: 48%;
        padding-bottom: 40%;
        margin-right: 4%;
        margin-bottom: 4%;

        &:nth-child(2n + 2) {
          margin-right: 0;
        }
      }

      .imager {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%);

        img {
          width: auto !important;
          max-width: 90%;
        }
      }
    }
  }

  .btn-container {
    max-width: 1000px;
    margin: 40px auto 0;
  }
}
</style>
